/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import { createBooking, getUser } from '../../helpers/lib/axios';
import { useAppToast } from '../../helpers/lib/useAppToast'
import { PopupButton, useCalendlyEventListener } from 'react-calendly';

export default function AppointmentForm() {
  const toast = useAppToast()
  const [name, setName] = useState('')
  const [age, setAge] = useState('')
  const [gender, setGender] = useState('')
  const [maritalStatus, setMaritalStatus] = useState('')
  const [cityOfResidence, setCityOfResidence] = useState('')
  const [complaint, setComplaint] = useState('')
  const [duration, setDuration] = useState('')
  const [expectations, setExpectations] = useState('')
  const [referral, setReferral] = useState('')
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getUser().then(user => {
      setName(user?.data?.firstName + ' ' + user?.data?.lastName)
      setGender(user?.data?.gender)
      setEmail(user?.data?.email)
    }).catch(err => console.log(err))
  }, [])

  useCalendlyEventListener({
    onEventScheduled: (e) => {
      handleSubmit(e);
    },
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name || !age || !gender || !maritalStatus || !cityOfResidence || !email || !complaint || !duration || !expectations || !referral) {
      toast({
        status: 'error',
        description: 'Please fill all required fields',
      })
      return;
    }
    try {
      setLoading(true);

      const payload = {
        email,
        name,
        age,
        gender,
        maritalStatus,
        cityOfResidence,
        complaint,
        therapyExpectations: expectations,
        duration,
        channel: referral
      };

      const booking = await createBooking(payload);
      if (booking?.data) {
        resetFormFields();
        toast({
          status: "success",
          description: "Booking created successfully",
        });
      }
    } catch (error) {
      toast({
        status: "error",
        description: "Failed to create booking",
      });
    } finally {
      setLoading(false);
    }
  };

  const resetFormFields = () => {
    setName("");
    setAge("");
    setGender("");
    setMaritalStatus("");
    setCityOfResidence("");
    setComplaint("");
    setDuration("");
    setExpectations("");
    setReferral("");
  };

  const labelClass = "text-[0.72rem] tracking-[0.12em] uppercase text-charcoal/60 font-medium pb-2 block";
  const inputClass = "bg-cream border border-cream-dark rounded-sm py-[0.85rem] px-4 text-charcoal font-sans text-[0.9rem] font-light outline-none transition-colors w-full focus:border-crimson/60 focus:bg-white";

  return (
    <form action="#" className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-5">

      <div>
        <label className={labelClass}>Name</label>
        <input type="text" className={inputClass} placeholder="John Doe" value={name} onChange={(e) => setName(e.target.value)} />
      </div>
      <div>
        <label className={labelClass}>Age</label>
        <input
          type="number"
          className={inputClass}
          placeholder="Enter age"
          value={age} onChange={(e) => setAge(e.target.value)}
        />
      </div>
      <div>
        <label className={labelClass}>Email</label>
        <input
          type="text"
          className={inputClass}
          placeholder="Enter email"
          value={email} onChange={(e) => setEmail(e.target.value)}
        />
      </div>
      <div>
        <label className={labelClass}>
          Gender
        </label>
        <select name="" id="" className={inputClass} value={gender} onChange={(e) => setGender(e.target.value)}>
          <option value="" disabled>Select gender</option>
          <option value="MALE">Male</option>
          <option value="FEMALE">Female</option>
        </select>
      </div>
      <div>
        <label className={labelClass}>
          Marital Status
        </label>
        <select name="" id="" className={inputClass} value={maritalStatus} onChange={(e) => setMaritalStatus(e.target.value)}>
          <option value="" disabled>Select marital status</option>
          <option value="Single">Single</option>
          <option value="Married">Married</option>
          <option value="Divorced">Divorced</option>
          <option value="Widowed">Widowed</option>
          <option value="Single Parent">Single Parent</option>
        </select>
      </div>
      <div>
        <label className={labelClass}>City of residence</label>
        <input type="text" className={inputClass} placeholder="Enter city" value={cityOfResidence} onChange={(e) => setCityOfResidence(e.target.value)} />
      </div>
      <div className="md:col-span-2">
        <label className={labelClass}>What is your presenting complaint?</label>
        <textarea type="text" className={inputClass} placeholder="Enter text" value={complaint} onChange={(e) => setComplaint(e.target.value)} rows="3" />
      </div>
      <div className="md:col-span-2">
        <label className={labelClass}>How long has this being going on?</label>
        <input type="text" className={inputClass} placeholder="Enter duration" value={duration} onChange={(e) => setDuration(e.target.value)} />
      </div>
      <div className="md:col-span-2">
        <label className={labelClass}>What are your expectations for therapy?</label>
        <textarea type="text" className={inputClass} placeholder="Enter text" value={expectations} onChange={(e) => setExpectations(e.target.value)} rows="3" />
      </div>
      <div className="md:col-span-2">
        <label className={labelClass}>
          How did you hear about us?
        </label>
        <select name="" id="" className={inputClass} value={referral} onChange={(e) => setReferral(e.target.value)}>
          <option value="" disabled>Select option</option>
          <option value="Instagram">Instagram</option>
          <option value="X (formally known as Twitter)">X (formally known as Twitter)</option>
          <option value="LinkedIn">LinkedIn</option>
          <option value="A friend on social media">A friend on social media</option>
          <option value="Word of mouth">Word of mouth</option>
        </select>
      </div>
      <div className="md:col-span-2 mt-4">
        {(name !== '' && age !== '' && gender !== '' && maritalStatus !== '' && cityOfResidence !== '' && email !== '' && complaint !== '' && duration !== '' && expectations !== '' && referral !== '') ? <PopupButton
          url="https://calendly.com/noohranigeria/30min"
          rootElement={document.getElementById("root")}
          text={loading ? "Loading..." : "Submit to Schedule"}
          textColor="#ffffff"
          color="#8B1A1A"
          disabled={!name || !age || !gender || !maritalStatus || !cityOfResidence || !email || !complaint || !duration || !expectations || !referral}
          className="inline-block bg-crimson text-white px-9 py-3.5 text-xs font-medium tracking-[0.12em] uppercase rounded-[2px] transition-all duration-250 hover:bg-crimson-dark hover:-translate-y-px hover:shadow-lg focus:outline-none"
        /> : <button className="inline-block bg-crimson/50 cursor-not-allowed text-white px-9 py-3.5 text-xs font-medium tracking-[0.12em] uppercase rounded-[2px]"
          disabled={!name || !age || !gender || !maritalStatus || !cityOfResidence || !email || !complaint || !duration || !expectations || !referral}
        >
          Fill all fields
        </button>}
      </div>
    </form>
  );
}
